import React from 'react';
import styled from 'styled-components';
import {
  SectionWrapper,
  HeadlineOne,
  Paragraph,
  HeadlineTwo,
} from 'components/atoms/SectionWrapper.style';
import ButtonContact from 'components/atoms/button/ButtonContact';

const First = styled.div`
  /* height: 350px; */
  /* margin-top: 100px; */
  text-align: justify;
  width: 95%;
  margin: 80px auto;
  padding: 15px;

  @media ${({ theme }) => theme.media.tablet} {
    width: 85%;
    padding: 30px;
    border: dashed 4px #218921;
  }
`;

const OzeSlider = () => (
  <>
    <First>
      <HeadlineOne>O NAS</HeadlineOne>
      {/* <Paragraph>
        Energia ze słońca to darmowy prąd dla każdego.
        <br /> Skontaktuj się z nami!
      </Paragraph> */}

      <Paragraph>
        Firma Elgreen OZE, która wchodzi w skład grupy Elgreen i jest podmiotem
        stworzonym do obsługi rozwiązań w dziedzinie odnawialnych źródeł
        energii. Mając na uwadze bardzo wysokie wymagania stawiane przez rynek
        usług OZE, dużą liczbę przeszkód, z którymi zmaga się branża dzięki
        nabytemu doświadczeniu i możliwościom wypracowanym przez lata na rynku
        energetycznym w Polsce jesteśmy w stanie sprostać najcięższym wyzwaniom.
        Dzięki wykwalifikowanej kadrze inżynierskiej oraz rozbudowanej
        strukturze organizacyjnej gwarantujemy wysoki standard świadczonych
        usług, pełen profesjonalizm i etykę pracy.
      </Paragraph>
      <Paragraph>
        Cechuje nas indywidulane podejście do każdej prowadzonej inwestycji,
        skuteczność we wdrażaniu nowych innowacyjnych rozwiązań, a także
        terminowość i sumienność.
      </Paragraph>
      <Paragraph>
        Obszary w jakich poruszamy się w branży OZE są:
        <ul>
          <li>Fotowoltaika i Pompy Ciepała </li>
          <li>Farmy fotowoltaicze</li>
          <li>Magazyny Energii</li>
          <li>Farmy wiatrowe </li>
          <li>Stacje ładowania pojazdów elektrycznych</li>
          <li>Audyty energetyczne</li>
          <li>Optymalizacja kosztów energii i gazu</li>
        </ul>
      </Paragraph>
      <Paragraph>Zapraszamy do zapoznania się z naszą ofertą</Paragraph>
    </First>
  </>
);

export default OzeSlider;
